import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CadObject } from '../../../models/cad-object.model';
import { drawingComplexityLabel } from '../../../models/drawing-file.model';

@Component({
  selector: 'app-cad-properties',
  imports: [CommonModule],
  templateUrl: './cad-properties.component.html',
  styleUrl: './cad-properties.component.scss',
})
export class CadPropertiesComponent {
  @Input({ required: true }) cadObject!: CadObject;

  get complexityLabel(): string {
    if (!this.cadObject.complexity) {
      return 'N/A';
    }
    return drawingComplexityLabel(this.cadObject.complexity);
  }

  formatCadVolume(baseMm3: number, unit: 'm³' | 'cm³' | 'mm³'): string {
    if (!baseMm3) return '0';

    const value =
      unit === 'mm³' ? baseMm3 : unit === 'cm³' ? baseMm3 / 1e3 : baseMm3 / 1e9;

    // Use significant figures instead of fixed decimal places
    // so precision scales properly for very small and very large volumes
    return Number(value.toPrecision(4)).toLocaleString('en-US', {
      maximumFractionDigits: 8,
    });
  }
}
